const Main = () => import("@/views/main.vue");
//车队
const waybillList = () => import("@/views/waybill/list");
const waybillDetail = () => import("@/views/waybill/detail");


export default [
    {
        path: "/waybillList",
        name: "waybillList",
        component: Main,
        meta: {
            name: "物流信息列表",
            unfold: false, //是否可以被展开
            hide: false, //是否隐藏
            iconType: "icon-icon-transportation"
        },
        redirect: {
            name: "waybillList"
        },
        children: [
            {
                path: "waybillList",
                name: "waybillList",
                component: waybillList,
                meta: {
                    name: "物流信息列表",
                    hide: false,
                    role: {
                        add: false,
                        edit: false,
                        delete: false,
                        detail: false
                    }
                },
                children: [
                    {
                        path: "waybillDetail",
                        name: "waybillDetail",
                        component: waybillDetail,
                        meta: {
                            name: "物流信息列表详情"
                        }
                    }
                ]
            },
        ]
    }
];
